import TwoColumnPlainRepository from "../TwoColumnPlainRepository"

export default class WhoWeAreTwoColumnPlainRepository extends TwoColumnPlainRepository {
    static schemaId = "company_twoColumnPlain"

    constructor() {
        super(WhoWeAreTwoColumnPlainRepository.schemaId)
    }
}
